<template>
  <div class="header-child header-purple">
    Payment Transaction
  </div>

  <div class="content-base">
    <div class="this-list" :class="valuePay.showAll === child.label ? '' : 'data-hide'" v-for="child in dataChild.value" :key="child.label">
      <div class="child-name">
        <p>{{ child.label }}</p>
      </div>

      <div v-if="dataPay.value">
        <div class="data-list" :class="pay.name_siswa === child.label ? 'padding-data' : ''" v-for="pay in dataPay.value.filter(item => item.name_siswa === child.label)" :key="pay.name_siswa" @click.capture="detailClickPay(pay)">
          <div class="subject-time" :class="[pay.payment_value === pay.income_value ? 'data-success' : '', pay.payment_value <= pay.income_value && pay.outstanding !== '0' ? 'data-mid' : '', pay.payment_date > pay.due_date ? 'data-danger' : '']" v-if="pay.name_siswa === child.label">
            <p :class="[pay.payment_value === pay.income_value ? 'success-text' : '', pay.payment_value <= pay.income_value && pay.outstanding !== '0' ? 'mid-text' : '']">
              {{ pay.income_type_name }}
              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="pay.payment_value === pay.income_value">
                <path d="M99.9998 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 99.9998 16.6667C54.1665 16.6667 16.6665 54.1667 16.6665 100C16.6665 145.833 54.1665 183.333 99.9998 183.333Z" stroke="#68B984" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M64.5835 100L88.1668 123.583L135.417 76.4167" stroke="#68B984" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="pay.payment_value === '0'">
                <path d="M100 64.5834V108.333M175.667 71.5V128.5C175.667 137.833 170.667 146.5 162.583 151.25L113.083 179.833C105 184.5 95 184.5 86.8334 179.833L37.3334 151.25C33.3481 148.939 30.0412 145.621 27.7446 141.627C25.4481 137.634 24.2429 133.107 24.25 128.5V71.5C24.25 62.1667 29.25 53.5 37.3334 48.75L86.8334 20.1667C94.9167 15.5 104.917 15.5 113.083 20.1667L162.583 48.75C170.667 53.5 175.667 62.0834 175.667 71.5Z" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M100 135V135.833" stroke="black" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="pay.payment_value <= pay.income_value && pay.outstanding !== '0'">
                <path d="M150.333 112.917C146.833 116.333 144.833 121.25 145.333 126.5C146.083 135.5 154.333 142.083 163.333 142.083H179.167V152C179.167 169.25 165.083 183.333 147.833 183.333H63.6667C70.5834 177.25 75 168.333 75 158.333C74.9994 152.054 73.2245 145.902 69.8799 140.587C66.5352 135.273 61.757 131.011 56.0958 128.294C50.4346 125.576 44.1208 124.514 37.882 125.228C31.6432 125.943 25.7333 128.406 20.8334 132.333V95.9166C20.8334 78.6666 34.9167 64.5833 52.1667 64.5833H147.833C165.083 64.5833 179.167 78.6666 179.167 95.9166V107.917H162.333C157.667 107.917 153.417 109.75 150.333 112.917Z" stroke="#E6B325" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.8334 95.9167V65.3333C20.8334 55.4167 26.9167 46.5833 36.1667 43.0833L102.333 18.0833C112.667 14.25 123.75 21.8333 123.75 32.9167V64.5833M58.3334 100H116.667M187.992 116.417V133.583C187.992 138.167 184.325 141.917 179.658 142.083H163.325C154.325 142.083 146.075 135.5 145.325 126.5C144.825 121.25 146.825 116.333 150.325 112.917C153.408 109.75 157.658 107.917 162.325 107.917H179.658C184.325 108.083 187.992 111.833 187.992 116.417Z" stroke="#E6B325" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M75 158.333C75 168.333 70.5834 177.25 63.6667 183.333C57.5899 188.693 49.7691 191.655 41.6667 191.667C23.25 191.667 8.33337 176.75 8.33337 158.333C8.33337 147.833 13.1667 138.417 20.8334 132.333C25.7333 128.406 31.6432 125.943 37.882 125.228C44.1208 124.514 50.4346 125.576 56.0958 128.294C61.757 131.011 66.5352 135.273 69.8799 140.587C73.2245 145.902 74.9994 152.054 75 158.333Z" stroke="#E6B325" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M43.75 147.917V160.417L33.3334 166.667" stroke="#E6B325" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </p>
            <p class="important-text">Total Payment: Rp {{ formatIdr(pay.payment_value) }}</p>
            <p>{{ formatDate(pay.payment_date) }}</p>
          </div>
        </div>
      </div>

      <div :class="pay.name_siswa === child.label ? 'more-data' : ''" v-show="valuePay.showAll !== pay.name_siswa && dataPay.value.filter(item => item.name_siswa === child.label).length > 1" v-for="pay in dataPay.value" :key="pay.name_siswa">
        <div class="btn-show-all" v-if="pay.name_siswa === child.label && dataPay.value.filter(item => item.name_siswa === child.label).length > 1" @click="clickAll(pay.name_siswa)">Show all</div>
      </div>

      <!-- No data -->
      <div v-if="dataPay.value">
        <div class="nodata-list" v-if="dataPay.value.filter(item => item.name_siswa === child.label).length == 0">
          <p>No Data!</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Load data -->
  <div v-if="loadData === true" class="this-loader" :class="loadData === true ? 'lay-load' : ''">
    <data-loader />
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUpdated, watchEffect, watch, computed } from 'vue';
  import axios from 'axios'
  import dayjs from 'dayjs';

  import DataLoader from '../../../components/Animation/DataLoader.vue';

  export default {
    name: "Payment Preview",

    components: {
      DataLoader
    },

    methods: {
      //  Format for date (1 January 2023)
      formatDate(dateString) {
        const date = dayjs(dateString);
        return date.format('D MMMM YYYY');
      },

      // Format IDR (2.000.000)
      formatIdr: value => (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    setup(props, {emit}) {
      // Get childern
      const method = 'GET'
      const url = 'parent-children'
      const value = reactive({
        parent_id: localStorage.getItem('user_id'),
        childern: "",
        nameyear: ""
      });
      const dataChild = reactive({})

      // Get payment
      const methodPay = 'GET'
      const urlPay = 'paymenttransaction-parent'
      const valuePay = reactive({
        category_id: "",
        department_id: "",
        financial_year_id: "",
        level_id: "",
        class_id: "",
        newbatch_id: "",
        candidatesgroup_id: "",
        user_parent: localStorage.getItem('user_id'),
        selectinv: false,
        showAll: "",
        transaction_type_code:'Payment'
      });
      const dataPay = reactive({})

      // Get data childern
      const getChild = async () => {
        await axios({
            method,
            url,
            params: value
        })
        .then(response => {
          dataChild.value = response.data.data
          loadData.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      // Get data payment
      const getPay = async () => {
        await axios({
            method: methodPay,
            url: urlPay,
            params: valuePay
        })
        .then(response => {
          dataPay.value = response.data.data
          loadData.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      // Modal detail
      const modalDetail = ref(false)

      const detailObject = ref();

      const detailCard = (invoice_no) => {
        detailObject.value = invoice_no;
        modalDetail.value = true
      }

      const closeClick = (event, item) => {
        if (modalDetail.value) {
          modalDetail.value = false
        } else {
          modalDetail.value = true
        }
      }

      // Load data
      const loadData = ref(true)

      const detailClickPay = (event) => {
        emit("detail-click", event)
      }

      // Show all data
      // const showAll = ref(false)

      const clickAll = (data) => {
        valuePay.showAll = data
      }

      onMounted(() => {
        getChild()
        getPay()
      })

      return {
        detailClickPay,
        method,
        url,
        value,
        dataChild,
        methodPay,
        urlPay,
        valuePay,
        dataPay,
        detailCard,
        detailObject,
        closeClick,
        modalDetail,
        loadData,
        // showAll,
        clickAll
      }
    }
  }
</script>

